module.exports = __webpack_public_path__ + "static/img/ads.c22fb88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ads.jpg
// module id = 731
// module chunks = 1